import { render } from "./BitkubConnectButton.vue?vue&type=template&id=0d026d51&scoped=true"
import script from "./BitkubConnectButton.vue?vue&type=script&lang=js"
export * from "./BitkubConnectButton.vue?vue&type=script&lang=js"

import "./BitkubConnectButton.vue?vue&type=style&index=0&id=0d026d51&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d026d51"]])

export default __exports__